import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosPutMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const HandleDeleteEvent = async (event_id) => {
  const DeleteRes = await AxiosPutMethod(`org/event/delete`, { event_id });
  if (DeleteRes.status === 200) {
    SuccessToast("Event Deleted!");
    return true;
  } else {
    if (DeleteRes.status === 401) HandleLogout();
    ErrorToast("Error on Delete Event");
    return null;
  }
};

export default HandleDeleteEvent;
